import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const couponsApi = createApi({
  reducerPath: 'couponsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Coupons'],
  endpoints: (builder) => ({
    get: builder.query({
      query: (data) => {
        const queryParams = []

        if (data.page) {
          queryParams.push(`page=${data.page}`)
        }

        if (data.perPage) {
          queryParams.push(`per_page=${data.perPage}`)
        }

        return queryParams.length ? `coupons?${queryParams.join('&')}` : 'coupons'
      },
      providesTags: (results) => {
        if (!results) {
          return [{ type: 'Coupons', id: 'LIST' }]
        }
        return [...results.data.map((i) => ({ type: 'Coupons', id: i.id })), { type: 'Coupons', id: 'LIST' }]
      },
    }),
    add: builder.mutation({
      query: (coupon) => ({ url: 'coupons', method: 'POST', body: coupon }),
      invalidatesTags: (results, error, { id }) => {
        return [{ type: 'Coupons', id }]
      },
    }),
    delete: builder.mutation({
      query: (coupon) => ({ url: `coupons/${coupon.id}`, method: 'DELETE' }),
      invalidatesTags: (results, error, { id }) => {
        return [{ type: 'Coupons', id }]
      },
    }),
  }),
})

export const { useGetQuery, useAddMutation, useDeleteMutation } = couponsApi

export default couponsApi
